export default "__VITE_ASSET__c1d0c98f__"